/**
 * English-only no-op.
 *
 * A previous session shipped a Hreflang component that emitted
 * `<link rel="alternate" hreflang=".."/>` tags for EN/FR pairs. That
 * feature was reverted for the English-only launch. `App.js` still
 * mounts this component, so we keep a null-render stub here to avoid
 * an import-time compilation error. If bilingual support returns
 * later, restore the original implementation from git history.
 */

export default function Hreflang() {
    return null;
}
